import React from 'react';
import { FaIcon } from '@innovationnorway/component-library';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { IconLookup } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

interface SubHeaderProps {
  iconDefiniton: IconLookup;
  title: string;
}

const Referralprocess: React.FC = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');

  const SubHeader = ({ iconDefiniton, title }: SubHeaderProps) => {
    return (
      <div className="display--flex gap--1">
        <span className="font-weight--bold">
          <FaIcon className="margin-right--1" icon={icon(iconDefiniton)} />
          {title}
        </span>
      </div>
    );
  };

  return (
    <>
      <h2>{tHelpAndSupport('commonQuestions.Referralprocess')}</h2>
      <div className="stack-medium">
        <SubHeader
          iconDefiniton={{ prefix: 'fal', iconName: 'list-check' }}
          title={tHelpAndSupport('commonQuestions.StepTitles.ChooseActor')}
        />
        <p>{tHelpAndSupport('commonQuestions.StepDescriptions.ChooseActor')}</p>
      </div>
      <div className="stack-medium">
        <SubHeader
          iconDefiniton={{ prefix: 'fal', iconName: 'envelope' }}
          title={tHelpAndSupport('commonQuestions.StepTitles.WriteReferral')}
        />
        <p>{tHelpAndSupport('commonQuestions.StepDescriptions.WriteReferral')}</p>
      </div>
      <div className="stack-medium">
        <SubHeader
          iconDefiniton={{ prefix: 'fal', iconName: 'paper-plane' }}
          title={tHelpAndSupport('commonQuestions.StepTitles.SendReferral')}
        />
        <p>{tHelpAndSupport('commonQuestions.StepDescriptions.SendReferral')}</p>
      </div>
      <div className="stack-medium">
        <SubHeader
          iconDefiniton={{ prefix: 'fal', iconName: 'square-check' }}
          title={tHelpAndSupport('commonQuestions.StepTitles.KeepWorking')}
        />
        <p>{tHelpAndSupport('commonQuestions.StepDescriptions.Archive')}</p>
      </div>
    </>
  );
};

export default Referralprocess;
